<!--// TODO: allow swipe interaction -->
<template>
  <div class="wl-slider flex flex-col" @touchstart.stop>
    <slot
      name="start"
      :index="modelValue"
      :arrivedState="arrivedState"
      :set-index="handleSetIndex"
    />
    <div
      :style="{
        gap: `${gap}px`,
        'scroll-padding-inline': `${scrollPadding - gap}px`,
      }"
      class="wl-slider__container no-scrollbar flex snap-x snap-mandatory overflow-x-scroll"
      ref="containerRef"
    >
      <div
        class="wl-slider__slide snap-start"
        :style="{
          flex: `0 0 ${normalizedSlideWidth}%`,
          width: normalizedSlideWidth ? `${normalizedSlideWidth}%` : undefined,
          'padding-left': `${index ? 0 : scrollPadding}px`,
          'padding-right': `${index < length - 1 ? 0 : scrollPadding}px`,
        }"
        v-for="(_, index) in length"
        :key="index"
        ref="slideRef"
      >
        <slot :index="index" />
      </div>
    </div>
    <slot
      name="end"
      :index="modelValue"
      :arrivedState="arrivedState"
      :set-index="handleSetIndex"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed, useTemplateRef, watch } from "vue";
import { useElementBounding, useInterval, useScroll } from "@vueuse/core";
import type { SliderProps } from "./types";

const {
  length,
  gap = 0,
  slideWidth = "auto",
  scrollPadding = 0,
  autoRotate,
  intervalMs = 4000,
} = defineProps<SliderProps>();

const modelValue = defineModel<number>({ default: 0 });
const containerRef = useTemplateRef("containerRef");
const slideRef = useTemplateRef("slideRef");
const { x, arrivedState, isScrolling } = useScroll(containerRef, {
  behavior: "smooth",
});
const firstSlide = computed(() => slideRef.value?.[0]);
const { width: slideBoundingWidth } = useElementBounding(firstSlide);

const { counter, pause, resume } = useInterval(() => intervalMs, {
  controls: true,
});

const normalizedSlideWidth = computed(() =>
  slideWidth === "auto" ? 0 : slideWidth,
);

watch(x, () => {
  const fraction = x.value / (slideBoundingWidth.value - gap);
  modelValue.value = Math.round(fraction);
});

watch(isScrolling, (value) => {
  if (!autoRotate) return;

  if (value) {
    pause();
    return;
  }

  resume();
});

watch(
  () => autoRotate,
  (value) => {
    if (value) {
      resume();

      return;
    }

    pause();
    modelValue.value = 0;
  },
  { immediate: true },
);

const handleSetIndex = (value: number): void => {
  x.value = value * (slideBoundingWidth.value - gap);
};

watch(counter, () => {
  handleSetIndex(modelValue.value < length - 1 ? modelValue.value + 1 : 0);
});
</script>
